<div class="informaciones-page">
  <div class="container">
    <header class="page-header">
<h1 class="page-title">Información Corporativa</h1>
    </header>

    <app-informaciones-grid></app-informaciones-grid>
  </div>
</div>
